const skpDetailTableContent = [
  {
    name: 'NO',
    keyValue: 'idx',
    type: 'idx',
    isActive: true,
    maxWidth: '100px',
  },
  {
    name: 'CHECK',
    keyValue: 'check',
    type: 'check',
    isActive: true,
    maxWidth: '50px',
  },
  { name: 'PRODUCT ID', keyValue: 'product_id', type: 'text', isActive: true },
  { name: 'PRODUCT NAME', keyValue: 'sku_name', type: 'text', isActive: true },
  { name: 'BARCODE NUMBER', keyValue: 'barcode', type: 'text', isActive: true },
  { name: 'BASE DISCOUNT', keyValue: 'rafaksi_base_discount', type: 'text', isActive: true },
  { name: 'PRICE PER UOM', keyValue: 'rafaksi_price_per_uom', type: 'currency', isActive: true },
  { name: '% REBATE', keyValue: 'rafaksi_rebate_percentage', type: 'percent', isActive: true },
  { name: 'REBATE PER UOM', keyValue: 'rafaksi_rebate_per_uom', type: 'currency', isActive: true },
  { name: 'QUANTITY PER UOM', keyValue: 'promotion_quantity', type: 'currency', isActive: true },
  { name: 'BUDGET PER UOM', keyValue: 'rafaksi_rebate_budget', type: 'currency', isActive: true },
  { name: 'MIN PURCHASE QTY', keyValue: 'min_purchase_qty', type: 'text', isActive: true },
  { name: 'UOM', keyValue: 'uom', type: 'text', isActive: true },
  { name: 'VALUE PER PCS', keyValue: 'freebies_value_per_uom', type: 'currency', isActive: true },
  { name: 'TOTAL VALUE', keyValue: 'freebies_total_value', type: 'currency', isActive: true },
  { name: 'FREE PRODUCT ID', keyValue: 'free_product_id', type: 'text', isActive: true },
  { name: 'FREE PRODUCT BARCODE', keyValue: 'free_product_barcode', type: 'text', isActive: true },
  { name: 'FREE PRODUCT NAME', keyValue: 'free_product_sku_name', type: 'text', isActive: true },
  { name: 'FREE PRODUCT UOM', keyValue: 'free_product_uom', type: 'text', isActive: true },
  { name: 'PROMO NAME', keyValue: 'free_product_promo_name', type: 'text', isActive: true },
  {
    name: 'FREE QUANTITY PER UOM',
    keyValue: 'free_product_quantity',
    type: 'currency',
    isActive: true,
  },
  {
    name: 'DOCUMENT NAME',
    keyValue: 'document_name',
    type: 'link',
    isActive: true,
  },
  {
    name: 'RAFAKSI TIER',
    keyValue: 'rafaksi_minimum_purchase',
    type: 'currency',
    isActive: true,
  },
  {
    name: 'QTY PER UOM',
    keyValue: 'rafaksi_qty_per_uom',
    type: 'text',
    isActive: true,
  },
  {
    name: 'BUDGET PER UOM',
    keyValue: 'rafaksi_budget_per_uom',
    type: 'currency',
    isActive: true,
  },
  { name: 'UPLOAD DATE', keyValue: 'created_at', type: 'date_detail_print', isActive: true },
  { name: 'UPLOADER', keyValue: 'created_by', type: 'text', isActive: true },
  { name: 'ROLE', keyValue: 'create_role', type: 'text', isActive: true },
  { name: 'ACTUAL QTY SOLD', keyValue: 'rafaksi_quantity_actual', type: 'text', isActive: true },
  { name: 'ACTUAL RAFAKSI', keyValue: 'rafaksi_rebate_actual', type: 'currency', isActive: true },
  { name: 'NUMBER', keyValue: 'number', type: 'text', isActive: true },
  { name: 'TYPE', keyValue: 'type', type: 'text', isActive: true },
  { name: 'AMOUNT', keyValue: 'amount', type: 'currency', isActive: true },
  { name: 'PAID DATE', keyValue: 'paid_date', type: 'date_detail_print', isActive: true },
  { name: 'CASH / GIFT', keyValue: 'ads_revenue_cash_gift', type: 'currency', isActive: true },
  { name: 'AMOUNT RECEIVE', keyValue: 'ads_revenue_amount', type: 'currency', isActive: true },
  { name: 'DETAIL / NOTES', keyValue: 'detail_gift_notes', type: 'text', isActive: true },
  { name: 'QUOTA PER DAY', keyValue: 'quota_per_day_value', type: 'text', isActive: true },
  { name: 'KETERANGAN', keyValue: 'remarks', type: 'text', isActive: true },
]

export default skpDetailTableContent
